export const COPY_SUCCESS_FEEDBACK_DEFAULT_DURATION_MS = 1000;
export const INSIGHT_NEGATIVE_FEEDBACK_MODAL_CUSTOM_STYLES = {
    content: { width: "550px", maxHeight: "90vh" },
};
